module.exports = __webpack_public_path__ + "img/tech_service_txt.f5ac3b10.png";